import * as types from "./mutation-types";
import initialState from "./state";

export default {
  [types.SET_USER](state, user) {
    state.user = user;
  },
  [types.SET_USER_TOKENS](state, { token, refreshToken }) {
    state.token = token;
    state.refreshToken = refreshToken;
  },
  [types.LOGOUT_USER](state) {
    state.user = { ...initialState.emptyUserObj };
  },
  [types.SET_AWS_ACCESS_TOKENS](state, { awsToken }) {
    state.awsToken = awsToken;
  },
  [types.SHOW_LOADER](state, status) {
    state.showLoader = status;
  },
  [types.SET_PARTICIPANT](state, user) {
    state.participant = user;
  },
  [types.SET_PARTICIPANT_TOKENS](state, { accesstoken, refreshtoken }) {
    state.token = accesstoken;
    state.refreshToken = refreshtoken;
  },
  [types.LOGOUT_PARTICIPANT](state) {
    state.participant = { ...initialState.participant };
  },
  [types.SESSION_EXPIRED](state, status = true) {
    state.sessionExpired = status;
  },
  [types.SET_PARTICIPANT_AWS_ACCESS_TOKEN](state, { participantAWSToken }) {
    state.participantAWSToken = participantAWSToken;
  },
  [types.SAVE_PARTICIPANT_DATA](state, participantRegistration) {
    state.participantRegistration = participantRegistration;
  },
  [types.SAVE_PARTICIPANT_STUDY_START_STATUS](state, data) {
    state.studyStartStatus = data;
  }
};
